import React, { useState } from 'react';

function NotLinked({ onRetry }) {
  const [checking, setChecking] = useState(false);

  const handleRetry = async () => {
    setChecking(true);
    try {
      await onRetry();
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-logo"><img src={`${process.env.PUBLIC_URL}/mp_smp_word_logo.png`} alt="MultiPunk" /></div>
      <h2>Привяжите аккаунт</h2>
      <p>Чтобы пользоваться приложением, привяжите свой Telegram к никнейму Minecraft на сайте MultiPunk.</p>
      <div className="card" style={{ textAlign: 'center' }}>
        <a
          href="https://multi-punk.net"
          target="_blank"
          rel="noopener noreferrer"
          className="primary-btn"
          style={{ display: 'inline-block', textDecoration: 'none', marginBottom: '10px' }}
        >
          Перейти на multi-punk.net
        </a>
        <button className="secondary-btn" onClick={handleRetry} disabled={checking}>
          {checking ? 'Проверка...' : 'Я привязал(а) — проверить снова'}
        </button>
      </div>
    </div>
  );
}

export default NotLinked;
